import React from 'react';
import { cn } from '../../lib/utils';
import { getDetailedRecommendations } from '../../utils/scoring';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiCheckCircle } = FiIcons;

export default function SectionScores({ sectionScores = [] }) {
  const getBarColor = (pct) => {
    if (pct >= 80) return 'bg-emerald-500';
    if (pct >= 60) return 'bg-yellow-500';
    if (pct >= 40) return 'bg-orange-500';
    return 'bg-red-500';
  };

  const getTextColor = (pct) => {
    if (pct >= 80) return 'text-emerald-700';
    if (pct >= 60) return 'text-yellow-700';
    if (pct >= 40) return 'text-orange-700';
    return 'text-red-700';
  };

  if (!sectionScores || sectionScores.length === 0) return null;

  return (
    <div className="mt-12">
      <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-2">
        Análisis detallado por área
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {sectionScores.map(sec => (
          <div key={sec.id} className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm transition-all hover:shadow-md print-break-inside-avoid">
            <div className="flex justify-between items-center mb-3">
              <h4 className="font-bold text-slate-800">{sec.title}</h4>
              <span className={cn("font-black text-lg", getTextColor(sec.percentage))}>{sec.percentage}%</span>
            </div>
            <div className="w-full h-2.5 bg-slate-100 rounded-full overflow-hidden mb-5">
              <div 
                className={cn("h-full rounded-full transition-all duration-1000", getBarColor(sec.percentage))} 
                style={{ width: `${sec.percentage}%` }}
              ></div>
            </div>
            {sec.percentage < 80 && (
              <div className="mt-4 space-y-3">
                <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-2">Recomendaciones clave</span>
                <div className="space-y-2">
                  {getDetailedRecommendations(sec.id).map((rec, idx) => (
                    <div key={idx} className="flex items-start gap-2 text-sm text-slate-600 bg-slate-50/50 p-2 rounded-lg border border-slate-100">
                      <SafeIcon icon={FiCheckCircle} className="text-blue-500 mt-0.5 flex-shrink-0" />
                      <span>{rec}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}